<template>
  <div class="page" :style="{ height:  '100%' }">
    <van-tabs class="collect-tabs" v-model="active">
      <van-tab
        v-for="(item, index) in tagList"
        :title="item ? item : '全部'"
        :key="index"
      >
      </van-tab>
    </van-tabs>
    <div class="collect-list">
      <div
        class="item"
        v-for="(item, index) in dataList"
        :key="index"
        @click="gotoDetail(item)"
      >
        <div class="left">
          <img :src="item.poster + '@160h_242w_1e_1c'" alt="" />
        </div>
        <div class="right">
          <div class="name">
            {{ item.title }}
          </div>
          <div class="desc">本保险由{{ item.insuranceCompany }}承保</div>
          <div class="price">
            <span class="fu">¥</span>
            <span class="num">{{ item.plans[0].cycle[0].price }}</span>
          </div>
        </div>
        <div class="line" v-if="index < dataList.length - 1"></div>
        <img
          class="collect"
          @click.stop="delCollect(item)"
          src="./assets/img/shoucl@2x.png"
        />
      </div>
      <van-empty v-if="noData" description="暂无收藏～" />
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog, Tab, Tabs, Empty } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";

export default {
  name: "Collect",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Empty.name]: Empty,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
      active: 0,
      tagList: [],
      dataList: [],
      params: {
        queryKey: "",
        pageNumber: 1,
        pageSize: 100,
        tags: "",
        collect: 1,
      },
      noData: false,
    };
  },
  watch: {
    active: function (val) {
      this.params.tags = this.tagList[val];
      this.getCollectList();
    },
  },
  mounted() {
    this.getTags();
    this.getCollectList();
  },
  beforeDestroy: function () {},
  methods: {
    async getTags() {
      //   api/insuranceProduction/getTags
      let res = await this.$http.post("/api/insuranceProduction/getTags", {
        companyId: this.publicData.companyId,
        accountId: this.publicData.id,
      });
      if (!res.code) {
        console.log("res", res);
        this.tagList = res.t;
      }
    },
    async getCollectList() {
      //   api/insuranceProduction/getList
      this.noData = false;
      this.params.accountId = this.publicData.id;
      let res = await this.$http.post(
        "/api/insuranceProduction/getList",
        this.params
      );
      if (!res.code) {
        console.log("res", res);
        if (res.list) {
          res.list.forEach((el) => {
            try {
              el.plans = JSON.parse(el.plans);
            } catch (error) {}
          });
        }

        this.dataList = res.list;
        if (!this.dataList.length) {
          this.noData = true;
        }
      }
    },
    async delCollect(item) {
      // collect/delete
      Dialog.confirm({
        title: "提示",
        message: `确定要取消收藏${item.title}吗？`,
      })
        .then(async () => {
          // on confirm
          let res = await this.$http.post("/api/collect/delete", {
            accountId: this.publicData.id,
            id: item.id,
            insuranceProductionId: item.id,
          });
          if (!res.code) {
            this.$toast("取消收藏成功！");
            this.getCollectList();
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    gotoDetail(item) {
      this.$router.push({
        name: "Detail",
        query: {
          id: item.uniqId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
    display: flex;
    flex-direction: column;
  .collect-list {
    overflow-y: scroll;
    .item {
      display: flex;
      padding: 0.21rem 0.15rem;
      box-sizing: border-box;
      // border-bottom: 1px solid#DDDDDD;;
      position: relative;
      .line {
        position: absolute;
        width: 100%;
        height: 1px;
        background: #ddd;
        bottom: 0;
        width: 3.45rem;
      }
      .collect {
        position: absolute;
        bottom: 0.28rem;
        right: 0.15rem;
        width: 0.17rem;
        height: 0.16rem;
      }
      .left {
        width: 1.1rem;
        height: 0.73rem;
        display: flex;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
          border-radius: 0.05rem;
        }
      }
      .right {
        padding: 7px 0;
        padding-left: 0.1rem;
        box-sizing: border-box;
        flex: 1;

        .name {
          font-size: 0.15rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 90%;
        }
        .desc {
          font-size: 0.11rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #888888;
          margin-top: 0.06rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 90%;
        }
        .price {
          display: flex;
          margin-top: 0.1rem;
          align-items: baseline;
          .fu {
            font-size: 0.12rem;
            font-family: PingFang;
            font-weight: 800;
            color: #ff7223;
            margin-right: 0.02rem;
          }
          .num {
            font-size: 0.24rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ff7223;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.page {
  .collect-tabs {
    background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
    .van-tabs__nav {
      background: rgba(0, 0, 0, 0);
      .van-tab {
        font-size: 0.14rem;
        font-family: PingFang;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.75);
        // line-height: 0.2rem;
        .van-tab__text {
          font-size: 0.14rem;
        }
        &.van-tab--active {
          font-size: 0.17rem;
          font-family: PingFang;
          font-weight: bold;
          color: #ffffff;
          .van-tab__text {
            font-size: 0.17rem;
          }
        }
      }
      .van-tabs__line {
        background-color: #fff;
        height: 0.03rem;
        width: 0.18rem;
        bottom: 21px;
      }
    }
  }
}
</style>